import React from "react";

const VideoComponent = (props) => {
    return (
        <video id={props.id} style={{visibility: 'hidden'}}>
            <source src={props.src} type="video/mp4"/>
            <source src={props.src} type="video/ogg"/>
        </video>
    )
}

export default VideoComponent;